import { render, staticRenderFns } from "./crosspermissions.vue?vue&type=template&id=47387860&scoped=true"
import script from "./crosspermissions.vue?vue&type=script&lang=js"
export * from "./crosspermissions.vue?vue&type=script&lang=js"
import style0 from "./crosspermissions.vue?vue&type=style&index=0&id=47387860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47387860",
  null
  
)

export default component.exports